import { render, staticRenderFns } from "./FilterTagsList.vue?vue&type=template&id=73358320&"
import script from "./FilterTagsList.vue?vue&type=script&lang=js&"
export * from "./FilterTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports